// Every app shortcut lives here. All are Ctrl combinations; rows with no label are
// placeholders the user will fill later.
export const SIDEBAR_GROUPS = [
  {
    title: "Add",
    items: [
      { key: "Ctrl+F1", code: "F1", label: "Add Customer A/c", to: "/masters/customer?focus=1", perm: "masters" },
      { key: "Ctrl+F2", code: "F2", label: "Add Item", to: "/items?new=1", perm: "items" },
      { key: "Ctrl+F3", code: "F3", label: "Conference", to: "/conference", perm: "sales" },
      { key: "Ctrl+F4", code: "F4", label: "" },
      { key: "Ctrl+F5", code: "F5", label: "Add Payment", to: "/payment-entry", perm: "payments" },
      { key: "Ctrl+F6", code: "F6", label: "Add Receipt", to: "/receipt-entry", perm: "payments" },
      { key: "Ctrl+F7", code: "F7", label: "Add Journal", to: "/journal", perm: "payments" },
      { key: "Ctrl+F8", code: "F8", label: "Add Sales", to: "/sales?new=1", perm: "sales" },
      { key: "Ctrl+F9", code: "F9", label: "Add Purchase", to: "/purchase?new=1", perm: "purchase" },
    ],
  },
  {
    title: "Display",
    items: [
      { key: "Ctrl+S", code: "KeyS", label: "Stock Status", to: "/inventory", perm: "read" },
      { key: "Ctrl+I", code: "KeyI", label: "Rate Finder", to: "/rate-finder", perm: "rates" },
      { key: "Ctrl+D", code: "KeyD", label: "Item Ledger", to: "/ledger", perm: "read" },
      { key: "Ctrl+L", code: "KeyL", label: "Customer Ledger", to: "/party-ledger", perm: "read" },
      { key: "Ctrl+A", code: "KeyA", label: "Customer wise Sales", to: "/reports?kind=sale&group=party", perm: "read" },
      { key: "Ctrl+P", code: "KeyP", label: "Purchase Register", to: "/purchase-register", perm: "read" },
      { key: "Ctrl+E", code: "KeyE", label: "" },
      { key: "Ctrl+B", code: "KeyB", label: "Bale & LR Report", to: "/bale-report", perm: "read" },
      { key: "Ctrl+H", code: "KeyH", label: "" },
      { key: "Ctrl+M", code: "KeyM", label: "Mill Pending Order", to: "/mill-orders/pending", perm: "purchase" },
      { key: "Ctrl+R", code: "KeyR", label: "Update Sale Rate", action: "sales-rate", perm: "items" },
    ],
  },
];

export const SIDEBAR_ITEMS = SIDEBAR_GROUPS.flatMap((g) => g.items);

// extra combinations that are not shown as sidebar rows
export const EXTRA_SHORTCUTS = [
  { key: "Ctrl+2", code: "Digit2", label: "Item Master", to: "/items", perm: "items" },
];

// non-navigating keys, listed in the help dialog
export const ACTION_KEYS = [
  ["F1", "Show this shortcuts list"],
  ["F2", "Save the open form"],
  ["Enter", "Move to the next cell; on the last cell adds a new row"],
  ["↓ / ↑", "Move down / up the same column in a grid"],
  ["← / →", "Move to the cell on the left / right in a grid"],
  ["Backspace", "On an empty cell, jumps back to the previous cell"],
  ["Drag corner", "Drag the small square at a cell's corner down to copy that value into rows below"],
  ["Esc", "Close or quit the open screen"],
  ["Ctrl+V", "Paste a block of rows from Excel into the Mill Order sheet"],
];

// Ctrl (or Cmd) + the key shown; placeholders and rows without rights are ignored.
export const matchSidebarKey = (e, allowed = []) => {
  if (!(e.ctrlKey || e.metaKey) || e.altKey || e.shiftKey) return null;
  const hit = [...SIDEBAR_ITEMS, ...EXTRA_SHORTCUTS].find((i) => i.code === e.code);
  if (!hit || !(hit.to || hit.action)) return null;
  if (hit.perm && !allowed.includes(hit.perm)) return null;
  return hit;
};
